import React, {useEffect, useState} from 'react';
import {HomeHeader, Slider, Nav, LazyImage, OnlineOff} from "../../Components";
import SimpleLineIcon from "react-simple-line-icons";
import {AssignCoupon, HomeData} from "./HomeServices";
import "./Home.scss";
import {useHistory, useLocation} from "react-router-dom";
import {useBasket, useDispatchResp, usePrompt, useResp} from "../../hooks";
import Platform from 'react-platform-js'
import toaster from 'toasted-notes';
import {StoreData} from "../StoreDetail/StoreDetailServices";
import {CampaignList, MenuList, MyRecentMerchant, RewardList} from "./Sections";
import {MyInvoiceList} from "./Sections/MyInvoiceList";
import {Menu} from "..";
import {detectEnglishLang, LogRequest} from "../../Services";
import {Modal, message, Button, notification} from 'antd';
import 'antd/dist/antd.css';
import CheckDomain from "../../Components/CheckDomain/CheckDomain";
import {FCMAllow} from "../../Components/NotificationAllow/FCMAllow";
import ReactPlayer from 'react-player'
import {MyRecentMerchantMenu} from "./Sections/MyRecentMerchantMenu";
import {
    FloatingMenu,
    MainButton,
    ChildButton,
} from 'react-floating-button-menu';

import { ClockCircleOutlined } from '@ant-design/icons';
import {MultipleList} from "./Sections/MultipleList";
import VideoSec from "./Sections/VideoSec";
import AudioSec from "./Sections/AudioSec";
import PollSec from "./Sections/pollSec";
import {ProductRegal} from "../../Components/ProductRegal/ProductRegal";
import ActualSec from "./Sections/ActualSec";
import CategorySliderSec from "./Sections/CategorySliderSec";
import TagBannerSec from "./Sections/TagBannerSec";
import TriadSec from "./Sections/TriadSec";
import FourSec from "./Sections/FourSec";
import HomeResponsive from "../HomeResponsive/HomeResponsive";
import BookingSec from "./Sections/BookingSec";
import DualBarSec from "./Sections/DualBarSec";
import ButtonListDesktop from "../DesktopComponents/ButtonListDesktop/ButtonListDesktop";
import ButtonListSec from "./Sections/ButtonListSec";
import SingleBarSec from "./Sections/SingleBarSec";
import SingleBannerSec from "./Sections/SingleBannerSec";
import TriadBigRightSec from "./Sections/TriadBigRightSec";
import TriadBigLeftSec from "./Sections/TriadBigLeftSec";
import {CategoryRegal} from "../../Components/CategoryRegal/ProductRegal";
import BlogRegalSec from "./Sections/BlogRegalSec";
import {TagRegal} from "../../Components/TagRegal/TagRegal";
import {OffRegal} from "../../OffRegal/OffRegal";
import DrShopHeader from "../../Components/DrShopHeader/DrShopHeader";
import PrescriptionSec from "./Sections/PrescriptionSec";
import {VideoDesktop} from "../DesktopComponents/VideoDesktop/VideoDesktop";
import {TextDesktop} from "../DesktopComponents/TextDesktop/TextDesktop";
import {TSlider} from "../../Components/TSlider/TSlider";
import {BrandRegal} from "../../Components/BrandRegal/BrandRegal";
import ServiceSec from "./Sections/ServiceSec";
import ProductRegalDesktopV3 from "../../Components/ProductRegalDesktopV3/ProductRegalDesktopV3";
import ProductRegalDesktopV3Mobile from "../../Components/ProductRegalDesktopV3Mobile/ProductRegalDesktopV3Mobile";
import {CategoryRegalV3} from "../../Components/CategoryRegalV3/CategoryRegalV3";
import {TagRegalMobileV3} from "../../Components/TagRegalMobileV3/TagRegalMobileV3";
import FooterMobile from "../DesktopComponents/FooterMobile/FooterMobile";
import {BrandRegalMobileV3} from "../../Components/BrandRegalMobileV3/BrandRegalMobileV3";


function Home() {

    //hooks
    const history = useHistory();
    const location = useLocation();
    const prompt = usePrompt();
    const resp = useResp();
    const set_resp = useDispatchResp();




    //states
    const [preload, setPreload] = useState(true);
    const [failed, setFailed] = useState(false);

    //fab btns
    const [isOpen, set_isOpen] = useState(false);

    const [button_list, set_button_list] = useState([]);
    const [button_list2, set_button_list2] = useState([]);
    const [slider, set_slider] = useState([]);
    const [single_bar, set_single_bar] = useState([]);
    const [banner, setBanner] = useState([]);
    const [dual_bar, set_dual_bar] = useState([]);
    const [dual_bar_a, set_dual_bar_a] = useState([]);
    const [triad_big_left, set_triad_big_left] = useState([]);

    const [left, set_left] = useState({});
    const [right_top, set_right_top] = useState({});
    const [right_bottom, set_right_bottom] = useState({});

    const [right, set_right] = useState({});
    const [left_top, set_left_top] = useState({});
    const [left_bottom, set_left_bottom] = useState({});

    const [homi, setHomi] = useState([]);
    const [notifHint, setNotifHint] = useState(false);


    //coupon
    const [coupon, set_coupon] = useState("");
    const [isCouponModalVisible, setIsCouponModalVisible] = useState(false);
    const [live, set_live] = useState(false);
    const [modalSW, set_modalSW] = useState(true);
    const [liveSrc, set_liveSrc] = useState("https://live.cdn.asset.aparat.com/b9bec55bfc3c464f980e5050441b7b19/livehls/esfahan_shora_musQ1_480p/1625985336500.ts?s=psDpYNA52DT4QITR-_eGDw&e=1626006161&ip=89.43.11.51");




    // const openNotifPermission = () =>{
    //     messaging.requestPermission()
    //         .then(async function() {
    //             const token = await messaging.getToken();
    //             console.log(token);
    //         })
    //         .catch(function(err) {
    //             console.log("Unable to get permission to notify.", err);
    //         });
    //     navigator.serviceWorker.addEventListener("message", (message) => {
    //         try{
    //             console.log(message.data);
    //             let notif = message.data["firebase-messaging-msg-data"].notification;
    //             console.log(notif)
    //         }catch (e) {
    //             console.log(e)
    //         }
    //     });
    // }




    Array.prototype.sortBy = function(p) {
        return this.slice(0).sort(function(a,b) {
            return (a[p] > b[p]) ? 1 : (a[p] < b[p]) ? -1 : 0;
        });
    }



    try {
        useEffect(() => {
            // console.log("location ... ",location);
            // if(location.state && location.state.customer){
            //     console.log("prompt ... ",prompt);
            //     if(prompt){
            //         prompt.prompt();
            //     }
            // }
            // history.replace('/',{...location.state,customer:null});
            //GG();
            // LogRequest({type:"CHROME_NOTIFICATION_DIALOG",meta:"ALLOW"})
            console.log("Location : ",location)
            if(location.state && location.state.coupon){
                //set coupon api
                assignCoupon(location.state.coupon)
            }
            getHome();
            checkGuestBasketMessages()


        }, [])


        const showMess = (productsList) => {
            const key = `open${Date.now()}`;
            let genList = ``;

            productsList.forEach(p =>{
                genList += `\n ${p} \n`
            })


            notification.config({
                duration: 7,
            });

            notification['warning']({
                message:"این موارد به علت ناموجود بودن از سبد شما حذف شد",
                description: (
                    <ul>
                        {productsList.map((p) =>{
                            return(
                                <li className="guest-message-item">
                                    {p}<br />
                                </li>
                            )
                        })}
                    </ul>
                ),
                key,
                style: {
                    zIndex:2003
                },
            });
        }

        const checkGuestBasketMessages = ()=>{
            let guestMessageLocal = localStorage.getItem('guestBasketResponse')
            if(guestMessageLocal){
                let guestMessages =  JSON.parse(guestMessageLocal)
                console.log("show Guest Messages : ",guestMessages)
                localStorage.removeItem('guestBasketResponse');
                if(guestMessages.not_available.length > 0){
                    showMess(guestMessages.not_available)
                }
            }
        }

        const assignCoupon = async (id) =>{
            try{
                let res= await AssignCoupon(id);
                set_coupon(location.state.coupon)
                setIsCouponModalVisible(true)
            }catch (e) {
                console.log(e)
            }
        }

        const GG = () =>{
            // import('../../init-fcm')
            //     .then(async ({messaging}) => {
            //         const token = await messaging.getToken();
            //         console.log("BBBBBBBBBBBBB : ",token)
            //     })
        }

        //Set Home
        const setHome = (home) => {

            let yy = home.data.sortBy('order');
            console.log("Home",yy)


            let sample_img = "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/ba/29/5c/img-worlds-of-adventure.jpg?w=1200&h=-1&s=1"



            yy.push({section_type:"prescription",order:1,items:[
                    {text:"gRTsRpP8hF@5QekSMR6t2",link_to_uid:"#ff7272"}
                ]})
            //
            yy.push({section_type:"video_sec",order:3,items:[
                    {text:"",link_to_uid:"https://"}
                ]})
            // yy.push({section_type:"text_sec",items:[
            //         {text:"5VcAyf38B8",link_to_uid:"#fae66c"}
            //     ]})



            // yy.push({section_type:"slider-header",order:2,items:[
            //         {id:1,title:"تایتل یک",image:sample_img},
            //         {id:2,title:"تایتل دو",image:sample_img,link_to_uid:"vaDjhax5TM"},
            //         {id:3,title:"تایتل سه",image:sample_img,link_to_uid:"ZhPPvNDMkx"},
            //         {id:4,title:"تایتل چهار",image:sample_img},
            //         {id:5,title:"تایتل پنج",image:sample_img},
            //         {id:6,title:"تایتل شش",image:sample_img},
            //
            //         {id:1,title:"تایتل یک",image:sample_img},
            //         {id:2,title:"تایتل دو",image:sample_img},
            //         {id:3,title:"تایتل سه",image:sample_img},
            //         {id:4,title:"تایتل چهار",image:sample_img,link_to_uid:"vaDjhax5TM"},
            //     ]})
            //
            //  yy.push({section_type:"triad_sec",order:2,items:[
            //      {id:1,title:"تایتل یک",image:sample_img,link_to_uid:"scan",link_to:"in_app_page"},
            //      {id:2,title:"تایتل دو",image:sample_img,link_to_uid:"scan",link_to:"in_app_page"},
            //      {id:3,title:"تایتل سه",image:sample_img,link_to_uid:"scan",link_to:"in_app_page"},
            //      ]})
            //
            // yy.push({section_type:"four_sec",order:2,items:[
            //         {id:1,title:"تایتل یک",image:sample_img,link_to_uid:"scan",link_to:"in_app_page"},
            //         {id:2,title:"تایتل دو",image:sample_img,link_to_uid:"store",link_to:"in_app_page"},
            //         {id:3,title:"تایتل سه",image:sample_img,link_to_uid:"scan",link_to:"in_app_page"},
            //         {id:4,title:"تایتل سه",image:sample_img,link_to_uid:"scan",link_to:"in_app_page"},
            //     ]})

            setHomi(yy)



            //find data ---
            let button_list_loc = home.data.find(data => data.section_type === "button_list");
            let button_list2_loc = home.data.filter(data => data.section_type === "button_list");
            let slider_loc = home.data.find(data => data.section_type === "slider");
            let single_bar_loc = home.data.filter(data => data.section_type === "single_bar");
            let dual_bar_loc = home.data.find(data => data.section_type === "dual_bar");
            let dual_bar_a_loc = home.data.filter(data => data.section_type === "dual_bar");
            // console.log("Dual : ",dual_bar_a_loc)
            let triad_big_left_loc = home.data.find(data => data.section_type === "triad_big_left");
            let triad_big_right_loc = home.data.find(data => data.section_type === "triad_big_right");
            let banner_loc = home.data.find(data => data.section_type === "single_banner");

            if (dual_bar_a_loc) {
                set_dual_bar_a(dual_bar_a_loc)
            }

            // set States
            if (banner_loc) {
                setBanner(banner_loc.items);
            }

            if (button_list_loc) {
                set_button_list(button_list_loc.items)
            }

            if (button_list2_loc) {
                set_button_list2(button_list2_loc)
            }


            if (slider_loc) {
                set_slider(slider_loc.items)
            }
            if (single_bar_loc) {
                let items = single_bar_loc.map(item=>item.items[0]);
                set_single_bar(items)
            }

            if (dual_bar_loc) {
                set_dual_bar(dual_bar_loc.items)
            }


            if (triad_big_left_loc) {
                set_triad_big_left(triad_big_left_loc.items)
            }








            if (triad_big_left_loc) {
                let left_loc = triad_big_left_loc.items.find(data => data.position === "left");
                let left_top_loc = triad_big_left_loc.items.find(data => data.position === "right_top");
                let left_bottom_loc = triad_big_left_loc.items.find(data => data.position === "right_bottom");
                if (left_loc) {
                    set_left(left_loc)
                }
                if (left_top_loc) {
                    set_left_top(left_top_loc)
                }
                if (left_bottom_loc) {
                    set_left_bottom(left_bottom_loc)
                }
            }


            if (triad_big_right_loc) {
                let right_loc = triad_big_right_loc.items.find(data => data.position === "right");
                let right_top_loc = triad_big_right_loc.items.find(data => data.position === "left_top");
                let right_bottom_loc = triad_big_right_loc.items.find(data => data.position === "left_bottom");
                if (right_loc) {
                    set_right(right_loc)
                }
                if (right_top_loc) {
                    set_right_top(right_top_loc)
                }
                if (right_bottom_loc) {
                    set_right_bottom(right_bottom_loc)
                }
            }


        }

        const getHome = async () => {
            // let localHome = localStorage.getItem('home');
            // let searchMall = localStorage.getItem('mallId');
            // if (localHome) {
            //     let ParsedHome = JSON.parse(localHome);
            //     if(ParsedHome.mall===searchMall){
            //         setPreload(false);
            //         // setHome(ParsedHome.data)
            //     }
            // }

            try {
                let home = await HomeData();
                home = {data:home}
                //localStorage.setItem('home', JSON.stringify({mall:searchMall,data:home}));
                setHome(home);
                setPreload(false);

            } catch (e) {
                setPreload(false);
            }

        }

        const goToTag = (tag)=>{
            let tagType = tag.split('@')[0];
            let tagUid = tag.split('@')[1];

            switch (tagType) {
                case "service":
                    history.push("/services",{tagLink: {tag_type:tagType,uid:tagUid}});
                    break;
                case "blog":
                    history.push("/blogs",{tagLink: {tag_type:tagType,uid:tagUid}})
                    break;
            }
        }


        const LinkDispatcher = (link,obj) => {
            switch (link) {
                case 'mall_campaigns':
                    history.push('/festivals')
                    break;
                case 'mall_campaign_details':
                    history.push(`/festival-detail/${obj.link_to_uid}`,{festival:{uid:obj.link_to_uid}})
                    break;
                case 'my_rewards':
                    history.push('/reward')
                    break;
                case 'in_app_page':
                    history.push(obj.link_to_uid,{obj:obj})
                    break;
                case 'in_tag_page':
                    goToTag(obj.link_to_uid)
                    break;
                case 'mall_merchant_details':
                    history.push(`/store-detail/${obj.link_to_uid}`,{store:{uid:obj.link_to_uid}})
                    // history.push('/store')
                    break;
                case 'merchant_online_store':
                    let mallID = localStorage.getItem("mallId");
                    //window.location.href = `https://www.digimaall.com/malls/${mallID}/merchants/${obj.link_to_uid}`;
                    // window.open(
                    //     `https://${window.location.host}/download/${mallID}/merchants/${obj.link_to_uid?obj.link_to_uid:""}`,
                    //
                    //     '_blank' // <- This is what makes it open in a new window.
                    // );
                    if(obj.link_to_uid){
                        history.push('/online-store/'+obj.link_to_uid)
                    }
                    break;
                case 'checkin':
                    history.push('/scan')
                    break;
                case 'merchant_product':
                    let replace = obj.link_to_uid.replace(/'/g, '"');
                    let parsedPay =JSON.parse(replace);
                    let mallI = localStorage.getItem("mallId");
                    //window.location.href = `https://www.digimaall.com/malls/${mallI}/merchants/${parsedPay.merchant_uid}/products/${parsedPay.product_uid}`
                    // window.open(
                    //     `https://${window.location.host}/download/${mallI}/merchants/${parsedPay.merchant_uid}/products/${parsedPay.product_uid}`,
                    //     '_blank' // <- This is what makes it open in a new window.
                    // );
                    if(parsedPay.merchant_uid && parsedPay.product_uid){
                        history.push(`/online-store-product/${parsedPay.merchant_uid}/${parsedPay.product_uid}`)
                    }
                    break;
                case 'merchant_category_without_subcategory':
                    history.push('/store')
                    break;
                case 'mall_food_court':
                    history.push('/store',{catLink:{uid:obj.link_to_uid}})
                    break;
                case 'credit_package':
                    history.push('/reward')
                    break;
                case 'mall_parking':
                    history.push('/store')
                    break;
                case 'mall_event_details':
                    history.push(`/event-detail/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                    // history.push(`/menu/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                    break;
                case 'merchant_menu':
                    //history.push(`/event-detail/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                    history.push(`/menu/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                    break;
                case 'live':
                    livePreview(obj)
                    break;
                case 'call_center':
                    document.location.href="tel:"+obj.link_to_uid;
                    break;
                case 'chat':
                    let local_user = localStorage.getItem("user")
                    let user_obj = JSON.parse(local_user)
                    let new_topic = obj.link_to_uid.replace("REPLACE",user_obj.uid)
                    history.push(`/chat/${new_topic}`)
                    break;
                default:
                    console.log("default")
            }
        }

        const livePreview = (obj)=>{
            // console.log("Live : ",obj)
            // set_liveSrc(obj.link_to_uid)
            window.open(obj.link_to_uid, "_blank") //t
            // set_modalSW(true)
            // set_live(true)
        }

        const showModal = () => {
            setIsCouponModalVisible(true);
        };

        const handleOk = () => {
            setIsCouponModalVisible(false);
        };

        const handleCancel = () => {
            setIsCouponModalVisible(false);
        };

        const handleLiveOk = () => {
            set_live(false);
            set_modalSW(false)
        };

        const handleLiveCancel = () => {
            set_live(false);
            set_modalSW(false)
        };

        return (
            <>
                {resp?<div className="home-container-res">
                    <HomeResponsive
                        right_bottom={right_bottom}
                        right_top={right_top}
                        right={right}
                        left={left}
                        left_bottom={left_bottom}
                        left_top={left_top}

                        homi={homi} LinkDispatcher={LinkDispatcher}/>
                </div>:null}
                {!resp?<div className="home-container" style={{overflow: "hidden"}}>
                    {/*<FCMAllow/>*/}


                    {modalSW ? <Modal visible={live} footer={null} onOk={handleLiveOk} onCancel={handleLiveCancel}>
                        <div>
                            <ReactPlayer
                                controls={true}
                                width='100%'
                                height='100%'
                                url={liveSrc}/>
                        </div>
                    </Modal> : null}


                    <Modal visible={isCouponModalVisible} footer={null} onOk={handleOk} onCancel={handleCancel}>
                    <div className="coupon-modal-container">
                    <div className="coupon-modal-header">
                    کوپن ها
                    </div>
                    <div className="coupon-modal-body">
                    <p>کوپن <span className="coupon_number">{coupon}</span> با موفقیت برای شما فعال شد , شما
                    هم اکنون میتوانید از این کوپن استفاده نمایید</p>
                    </div>
                    </div>
                    </Modal>
                    {/*<HomeHeader/>*/}
                    <DrShopHeader home={true}/>
                    {/*<div className="header-margin"></div>*/}

                    {!preload ? <div className="new-home">

                        {/*<span>{Platform.UA}</span>*/}
                        {homi.map(item => {
                            switch (item.section_type) {
                                case 'my_recent_merchant':
                                    return (
                                        <MyRecentMerchant item={item}/>
                                    )
                                    break;
                                case 'merchant_menu':
                                    return (
                                        <MyRecentMerchantMenu item={item}/>
                                    )
                                    break;
                                case 'video_content':
                                    return (
                                        // <VideoSec item={item}/>
                                        <VideoDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                    )
                                    break;
                                case 'poll':
                                    return (
                                        <PollSec item={item}/>
                                    )
                                    break;
                                case 'audio_content':
                                    return (
                                        <AudioSec item={item}/>
                                    )
                                    break;
                                case 'triad_sec':
                                    return (
                                        <TriadSec item={item} link={LinkDispatcher}/>
                                    )
                                    break;
                                case 'four_sec':
                                    return (
                                        <FourSec item={item} link={LinkDispatcher}/>
                                    )
                                    break;
                                case 'category_slider':
                                    return (
                                        <CategorySliderSec item={item}/>
                                    )
                                    break;
                                case 'tag_banner':
                                    return (
                                        <TagBannerSec item={item}/>
                                    )
                                    break;
                                case 'service_section':
                                    return (
                                        <ServiceSec item={item} LinkDispatcher={LinkDispatcher}/>
                                    )
                                    break;
                                case 'triad_big_right_slider':
                                    return (
                                        <ServiceSec item={item} LinkDispatcher={LinkDispatcher}/>
                                    )
                                    break;

                                case 'blog_regal':
                                    return (
                                        <BlogRegalSec item={item}/>
                                    )
                                    break;
                                case 'product_brand_regal':
                                    return (
                                        // <BrandRegal item={item}/>
                                        <BrandRegalMobileV3 item={item}/>
                                    )
                                    break;
                                case 'reward_list':
                                    return (
                                        <RewardList item={item}/>
                                    )
                                    break;
                                case "mall_products":
                                    return (
                                        <ProductRegal item={item}/>
                                    )
                                    break;
                                case "product_category":
                                    return (
                                        <CategoryRegalV3 item={item} sort={true}/>
                                    )
                                case "product_tag":
                                    return (
                                        <TagRegalMobileV3 item={item}/>
                                    )
                                    break;
                                case "off_product":
                                    return (
                                        <OffRegal item={item}/>
                                    )
                                    break;
                                case 'video_section':
                                    return (
                                        <VideoSec item={item} LinkDispatcher={LinkDispatcher}/>
                                    )
                                    break;
                                case 'text_content':
                                    return (
                                        <TextDesktop item={item} LinkDispatcher={LinkDispatcher}/>
                                    )
                                    break;
                                case 'campaign_list':
                                    return (
                                        <CampaignList item={item}/>
                                    )
                                    break;
                                case 'multiple_banner':
                                    return (
                                        <MultipleList item={item}/>
                                    )
                                    break;
                                case 'my_invoice_list':
                                    return (
                                        <MyInvoiceList item={item}/>
                                    )
                                    break;
                                case 'slider':
                                    return (
                                        // <DualSliderDesktop uid={item.uid} item={item} dispatch={LinkDispatcher} data={item.items}/>
                                        <div style={item.order!==1?{margin: "20px 16px 0 16px"}:{}}>
                                            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
                                            <Slider uid={item.uid} item={item} dispatch={LinkDispatcher}
                                                    data={item.items}/>
                                        </div>
                                    )
                                    break;
                                case 'triad_big_left_slider':
                                    return (
                                        <TSlider item={item}/>
                                    )
                                    break;
                                case 'dual_bar':
                                    return (
                                        <DualBarSec item={item} LinkDispatcher={LinkDispatcher}/>
                                    )
                                    break;
                                case 'actual_size_banner':
                                    return (
                                        <ActualSec item={item} link={LinkDispatcher}/>
                                        //<BookingSec item={item} link={LinkDispatcher}/>
                                    )
                                    break;
                                case 'single_bar':
                                    return (
                                        <SingleBarSec item={item} link={LinkDispatcher}/>
                                    )
                                    break;
                                case 'single_banner':
                                    return (
                                        <SingleBannerSec item={item} link={LinkDispatcher}/>
                                    )
                                    break;
                                case 'triad_big_right':
                                    return (
                                        <TriadBigRightSec item={item} right={right} right_bottom={right_bottom} right_top={right_top} LinkDispatcher={LinkDispatcher}/>
                                    )
                                    break;
                                case 'triad_big_left':
                                    return (
                                        <TriadBigLeftSec item={item} left={left} LinkDispatcher={LinkDispatcher} left_bottom={left_bottom} left_top={left_top} />
                                    )
                                    break;

                                case 'button_list':
                                    return (
                                        <ButtonListSec item={item} LinkDispatcher={LinkDispatcher}/>
                                    )
                                    break;
                                // case 'prescription':
                                //     return (
                                //         <PrescriptionSec item={item} LinkDispatcher={LinkDispatcher}/>
                                //     )
                                //     break;
                            }
                        })}
                        <FooterMobile/>
                    </div> : <div className="customer-preLoading">
                        {!failed ? <div className="customer-preloading-body">
                            <img src="/svg/pre.gif" alt=""/>
                            {/*<span>درحال دریافت اطلاعات</span>*/}
                        </div> : <div className="customer-failed-body">
                            <img src="/svg/failed.svg" alt=""/>
                            <span>اطلاعاتی موجود نیست</span>
                        </div>}
                    </div>}


                    <Nav/>
                    </div>:null}
                </>
        )
    }catch (e) {
        console.log('Error');
    }
}

export {Home};
